var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5531 4C21.4622 3.99064 21.3706 3.99064 21.2798 4H2.6131C2.49346 4.00185 2.37462 4.01979 2.25977 4.05334L11.8931 13.6467L21.5531 4Z",
    fill: "#050033",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.54 4.92667L12.8333 14.5933C12.5835 14.8417 12.2455 14.9811 11.8933 14.9811C11.541 14.9811 11.2031 14.8417 10.9533 14.5933L1.33329 5C1.30371 5.10869 1.28803 5.2207 1.28662 5.33333V18.6667C1.28662 19.0203 1.4271 19.3594 1.67715 19.6095C1.92719 19.8595 2.26633 20 2.61995 20H21.2866C21.6402 20 21.9794 19.8595 22.2294 19.6095C22.4795 19.3594 22.62 19.0203 22.62 18.6667V5.33333C22.6146 5.19444 22.5877 5.05722 22.54 4.92667V4.92667ZM3.53329 18.6667H2.60662V17.7133L7.45329 12.9067L8.39329 13.8467L3.53329 18.6667ZM21.2733 18.6667H20.34L15.48 13.8467L16.42 12.9067L21.2666 17.7133L21.2733 18.6667Z",
    fill: "#050033",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ee3420cf616054080b9897b8148cd139.svg";
export { ForwardRef as ReactComponent };